/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const SET_VALUE = 'SET_VALUE';
export const SET_VALUE_SUCCESS = 'SET_VALUE_SUCCESS';
export const SET_VALUE_ERROR = 'SET_VALUE_ERROR';

export interface SetValueAction {
  type: typeof SET_VALUE;
  payload?: any;
};

export interface SetValueSuccessAction {
  type: typeof SET_VALUE_SUCCESS;
  payload?: any;
};

export interface SetValueErrorAction {
  type: typeof SET_VALUE_ERROR;
  payload?: any;
};
